import React from "react";
import { useEffect, useState } from "react";
import "../../../TabList/ProfileSetting/ProfileSetting.css";

const AwayConfirmationModal = ({
    openUserSched = () => {},
    onClose = () => {},
}) => {

  const handleClose = () => {
    const today = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
    localStorage.setItem('awayLastShownDate', today);
    onClose();
  };

  const openSchedule = () => {
    const today = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
    localStorage.setItem('awayLastShownDate', today);
    openUserSched();
    // handleClose();
  };

  return (
    <div className="user-status-confirmation-modal">
      <div className="user-status-confirmation-container" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
            Important Reminder !
          </h5>
          <span className="text-sm">Your availability status is set to "Away".</span>
          <span className="text-sm">Don't forget to update your weekly schedule</span>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button"
              style={{ marginRight: "10px" }}
              className="btn-hubchart btn-hubchart-close btn-sm schedule-action-cancel"
              onClick={() => handleClose()}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="btn-sm btn-hubchart btn-hubchart-primary schedule-update-save"
              onClick={() => openSchedule()}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwayConfirmationModal;
